export const RENTALS = 'rentals';
export const RENTAL_PRODUCTS_PATH = `/${RENTALS}`;
export const CATEGORIES = 'categories';
export const CATEGORIES_PATH = `/${CATEGORIES}`;
export const RESERVATIONS = 'reservations';
export const RESERVATIONS_PATH = `/${RESERVATIONS}/`;
const RESERVATION_LINK = 'reservation';
export const RESERVATION_OVERVIEW_LINK = `${RESERVATION_LINK}/overview/`;
export const RESERVATION_OVERVIEW_PATH = `/${RESERVATION_OVERVIEW_LINK}`;
export const PORTALS = 'booking-portals';
export const PORTALS_PATH = `/${PORTALS}`;
